import React, { Component } from "react";
import { Link } from "react-router-dom";

import UI from "../../../actions/ui-helper";
import StringUtil from "../../../actions/string";

let wrapStyle = {
  whiteSpace: "pre-wrap",
  fontSize: "12px"
}

class ConsultaProcedimentoResultado extends Component {

  componentWillUpdate() {
    UI.destroyTable(this.tableId);
  }

  componentDidUpdate() {
    UI.dataTable(this.tableId);
  }

  render() {
    if (this.props.resultado.length === 0) {
      return false;
    }
    this.tableId = StringUtil.uuid(5);

    return (
      <div className="row">
        <div className="col-12 grid-margin">
          <div className="row">
            <div className="col-12 table-responsive">
              <table key={StringUtil.uuid(5)} id={this.tableId} className="table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Código</th>
                    <th>Descrição</th>
                    <th>Unidade</th>
                    <th>Valor (R$)</th>
                    <th>Opções</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.resultado.map((procedimento, i) => {
                    return (
                      <tr key={procedimento.id}>
                        <td>{procedimento.id}</td>
                        <td>{procedimento.codigo}</td>
                        <td style={wrapStyle}><div>{procedimento.descricao}</div></td>
                        <td>
                          {procedimento.unidade === 1 && <div className="badge badge-none badge-gray badge-xs">Hora</div>}
                          {procedimento.unidade === 2 && <div className="badge badge-none badge-gray badge-xs">Lançamento</div>}
                        </td>
                        <td>{parseFloat(procedimento.valorReceber).toFixed(2)}</td>
                        <td>
                          <button className="btn btn-xs btn-light btn-option icon-btn" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i className="fa fa-cog"></i>
                          </button>
                          <div className="dropdown-menu">
                            <Link
                              to={"/procedimento/cadastro/" + procedimento.id}
                              className="dropdown-item"><i className="fa fa-edit"></i>&nbsp;Editar</Link>
                            <Link
                              to={"/procedimento/auditoria/" + procedimento.id}
                              className="dropdown-item"><i className="fa fa-clock-o"></i>&nbsp;Auditoria</Link>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ConsultaProcedimentoResultado;
